import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentChart1 } from "../components/ComponentChart1";
import { ComponentChart2 } from "../components/ComponentChart2";
import { ContextReport1 } from "../Context";
import { REPORT_APE_ID, REPORT_ID } from '../constants';

export const report1ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_APE_ID === input.identification.reportId || REPORT_ID === input.identification.reportId) {
    if (identification.componentId === "chart-area-production-yield") {
      input.component = <ComponentChart1 context={componentContext as ContextReport1}></ComponentChart1>;
    }
    if (identification.componentId === "chart-net-trade") {
      input.component = <ComponentChart2 context={componentContext as ContextReport1}></ComponentChart2>;
    }
  }
  return next(input);
};
